import React from "react";
import { useSmartNavigate } from '@/hooks/use-smart-navigate';

export const Equipment_CategoryProps = {
    title: 'Facility Category',
    description: '',
    name: 'equipmentCategory',
}

const GotoDetail = ({ id, label }) => {
    const { navigateAndCloseTabs } = useSmartNavigate();
    const handleClick = (e) => {
        e.stopPropagation();
        navigateAndCloseTabs(`/admin/equipment-category-detail/${id}`, '/admin/equipment-category-detail/');
    };
    return label
        ? <a onClick={handleClick}>{label}</a>
        : <a onClick={handleClick}><i className="fas fa-expand-arrows-alt text-lg"></i></a>;
}


export const Equipment_CategoryColumns = [
    {
        title: 'key',
        dataIndex: 'id',
        key: 'id',
        editable: false,
        search: false,
        importIngore: true,
        width: '4%',
        hideInTable: true,
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        search: false,
        edit: true,
        sorter: (a, b) => a.name?.localeCompare(b.name),
        formItemProps: {
            rules: [
                {
                    required: true,
                    message: 'required',
                },
            ],
        },
        render: (text, record) => (
            <GotoDetail id={record.id} label={text} />
        )
    },
    {
        title: 'Spec1',
        dataIndex: 'spec1',
        key: 'spec1',
        edit: true,
        hideInTable: window.innerWidth < 760,
        sorter: (a, b) => a.location?.localeCompare(b.location),
    },
    {
        title: 'Spec2',
        dataIndex: 'spec2',
        key: 'spec2',
        edit: true,
        hideInTable: window.innerWidth < 760,
        sorter: (a, b) => a.location?.localeCompare(b.location),
    },
    {
        title: 'Spec3',
        dataIndex: 'spec3',
        key: 'spec3',
        edit: true,
        hideInTable: window.innerWidth < 760,
        sorter: (a, b) => a.location?.localeCompare(b.location),
    },
    {
        title: 'Spec4',
        dataIndex: 'spec4',
        key: 'spec4',
        edit: true,
        hideInTable: window.innerWidth < 760,
        sorter: (a, b) => a.location?.localeCompare(b.location),
    },
    {
        title: 'Life Expectancy (Years)',
        dataIndex: 'life_expectancy',
        key: 'life_expectancy',
        edit: true,
        hideInTable: window.innerWidth < 760,
        align: 'right', // 数字列右对齐
        sorter: (a, b) => (a.life_expectancy || 0) - (b.life_expectancy || 0),
        formItemProps: {
            rules: [
                {
                    pattern: /^[0-9]\d*$/,
                    message: 'Must be a positive integer',
                },
            ],
        },
    },
    {
        title: 'Comment',
        dataIndex: 'comment',
        key: 'comment',
        hideInTable: window.innerWidth < 760,
        edit: true
    },
    // {
    //     title: '',
    //     valueType: 'option',
    //     width: '6rem',
    //     importIngore: true,
    //     render: (text, record, _, action) => (
    //         <div className={'space-around'}>
    //             <a
    //                 key="editable"
    //                 onClick={() => (action?.startEditable?.(record.id))}
    //             >
    //                 <i className="fas fa-edit text-lg"></i>
    //             </a>
    //             <GotoDetail id={record.id} />
    //         </div>
    //     ),
    // },
];
